<ng-container *transloco="let t; prefix: 'org_profile'">
  <div class="drawer drawer-end z-[100]">
    <input id="org-profile" type="checkbox" class="drawer-toggle" />

    <div class="drawer-side">
      <label
        for="org-profile"
        aria-label="close sidebar"
        class="drawer-overlay"
        (click)="resetStates()"
      ></label>

      <div
        class="flex flex-col bg-white dark:bg-base-200 w-full md:w-96 text-base-content min-h-full py-2 px-4 transition-all duration-100 relative"
      >
        <div
          class="sticky-nav flex md:hidden justify-start items-center w-full !bg-white dark:!bg-base-200 py-2"
        >
          <label
            for="org-profile"
            class="drawer-button btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
            (click)="resetStates()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </label>
        </div>
        <div
          class="sticky-nav hidden md:flex justify-end items-center w-full !bg-white dark:!bg-base-200 py-2"
        >
          <label
            for="org-profile"
            class="drawer-button btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
            (click)="resetStates()"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </label>
        </div>

        <h3 class="text-2xl font-semibold mt-2 px-2">
          {{ t("org_profile") }}
        </h3>

        <div class="flex mt-5 w-full mb-4">
          <div
            role="tablist"
            class="tabs tabs-boxed flex shadow font-semibold bg-base-300 dark:bg-base-100 rounded-box p-2 w-full"
            (click)="toggleTabs()"
          >
            <a
              role="tab"
              class="tab flex-1 rounded-box transition-all duration-200"
              [ngClass]="{
                'tab-active': isProfile(),
              }"
              >{{ t("edit_profile") }}</a
            >
            <a
              role="tab"
              class="tab flex-1 rounded-box transition-all duration-200"
              [ngClass]="{
                'tab-active': isPreview(),
              }"
              >{{ t("preview") }}</a
            >
          </div>
        </div>
        @if (isProfile()) {
          <div
            class="flex flex-col gap-2 bg-base-200 dark:bg-base-100 rounded-box p-2 h-full"
          >
            <div class="collapse collapse-arrow bg-white dark:bg-base-200">
              <input
                [(ngModel)]="isBasicProfile"
                type="checkbox"
                name="basic_profile"
              />
              <div
                class="collapse-title font-normal flex items-center text-base"
              >
                <span>{{ t("basic_profile") }}</span>
              </div>
              <div class="collapse-content bg-white dark:bg-base-200">
                <form #orgProfileForm="ngForm" class="w-full">
                  <div class="flex justify-start items-center my-2 w-full">
                    <button
                      [disabled]="loading()"
                      (click)="toggleEdit()"
                      class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
                    >
                      @if (isEdit()) {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-circle-xmark"></i>
                          <span class="mt-1" *transloco="let t">{{
                            t("cancel")
                          }}</span>
                        </span>
                      } @else {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-pen-to-square"></i>
                          <span class="mt-1">{{ t("edit_profile") }}</span>
                        </span>
                      }
                    </button>
                    <button
                      (click)="updateOrgProfile()"
                      type="button"
                      [disabled]="loading() || !orgProfileForm.valid"
                      *ngIf="isEdit()"
                      class="btn btn-success btn-xs rounded-box ml-auto"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgProfileForm.valid,
                            'text-neutral-600': orgProfileForm.invalid,
                          }"
                        >
                          <i class="fa-light text-sm fa-circle-check"></i>
                          <span class="mt-1">{{ t("save_profile") }}</span>
                        </span>
                      }
                    </button>
                  </div>
                  <div class="grid grid-cols-1 gap-2">
                    <div
                      class="flex flex-col justify-center p-4 bg-neutral-100 dark:bg-base-100 rounded-box"
                    >
                      <p class="text-left w-full text-base mb-1">
                        {{ t("logo") }}
                      </p>
                      <div class="avatar self-center">
                        <div class="max-w-28 w-28 overflow-hidden relative">
                          @if (!isEdit() && logo()) {
                            <img
                              class="absolute w-full h-full rounded-md object-cover"
                              [src]="logoLink()"
                            />
                          } @else {
                            <qwiko-image-uploader
                              [updateItem]="true"
                              [currentFile]="logoLink()"
                              [currentFileID]="logo()?.id ?? null"
                              [contextCollection]="'org'"
                              [contextFieldName]="'logo'"
                              [contextID]="org()?.id || null"
                              (file)="logo.set($event)"
                              [disabled]="!isEdit()"
                              [directusClient]="accountsAppInstance"
                            ></qwiko-image-uploader>
                          }
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex flex-col justify-center p-4 bg-neutral-100 dark:bg-base-100 rounded-box"
                    >
                      <p class="text-left w-full mb-1 text-base">
                        {{ t("banner") }}
                      </p>
                      <div class="w-full h-32">
                        @if (!isEdit() && banner()) {
                          <img
                            class="w-full h-full object-cover rounded-box border-[8px] border-base-100 dark:border-base-200"
                            [src]="bannerLink()"
                          />
                        } @else {
                          <qwiko-image-uploader
                            [updateItem]="true"
                            [currentFile]="bannerLink()"
                            [currentFileID]="banner()?.id ?? null"
                            [contextCollection]="'org'"
                            [contextFieldName]="'banner'"
                            [contextID]="org()?.id ?? null"
                            (file)="banner.set($event)"
                            [disabled]="!isEdit()"
                            [directusClient]="accountsAppInstance"
                          ></qwiko-image-uploader>
                        }
                      </div>
                      <!-- <div class="avatar">
                      </div> -->
                    </div>

                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("store_name") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <input
                        #storeName="ngModel"
                        [(ngModel)]="store_name"
                        type="text"
                        name="store_name"
                        [placeholder]="t('store_name_placeholder')"
                        [ngClass]="
                          storeName.invalid && storeName.touched
                            ? 'input-error text-error'
                            : ''
                        "
                        required
                        [disabled]="!isEdit() || loading()"
                        class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                      />
                      <div
                        [ngClass]="
                          storeName.invalid && storeName.touched ? '' : 'hidden'
                        "
                        class="label"
                      >
                        <span class="label-text-alt text-error">{{
                          t("store_name_error")
                        }}</span>
                      </div>
                    </label>
                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("name") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <input
                        #orgName="ngModel"
                        [(ngModel)]="name"
                        type="text"
                        name="name"
                        [placeholder]="t('name_placeholder')"
                        [ngClass]="
                          orgName.invalid && orgName.touched
                            ? 'input-error text-error'
                            : ''
                        "
                        [disabled]="!isEdit() || loading()"
                        required
                        class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                      />
                      <div
                        [ngClass]="
                          orgName.invalid && orgName.touched ? '' : 'hidden'
                        "
                        class="label"
                      >
                        <span class="label-text-alt text-error">{{
                          t("name_error")
                        }}</span>
                      </div>
                    </label>
                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("category") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <input
                        hidden
                        type="text"
                        name="category"
                        required
                        [(ngModel)]="selectedCategory"
                      />
                      <button
                        type="button"
                        [disabled]="!isEdit() || loading()"
                        (click)="openCategoryModal()"
                        class="!bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row font-normal hover:bg-base-300 hover:border-neutral-400 items-center justify-between px-4 py-2 rounded-box text-sm text-base-content w-full"
                      >
                        @if (selectedCategory()) {
                          <div
                            class="flex flex-row gap-2 justify-start items-center"
                          >
                            <span class="mt-1 !text-base-content">{{
                              selectedCategory()?.name
                            }}</span>
                          </div>
                        } @else {
                          <div
                            class="flex flex-row gap-2 justify-center items-center"
                          >
                            <span class="mt-1">{{ t("select_category") }}</span>
                          </div>
                        }
                        <i class="fa-solid fa-chevron-down text-lg mr-1"></i>
                      </button>
                    </label>
                    <button
                      (click)="updateOrgProfile()"
                      type="button"
                      [disabled]="loading() || !orgProfileForm.valid"
                      *ngIf="isEdit()"
                      class="btn btn-success btn-md rounded-box w-full"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgProfileForm.valid,
                            'text-neutral-600': orgProfileForm.invalid,
                          }"
                        >
                          <i class="fa-light text-lg fa-circle-check"></i>
                          <span class="text-lg mt-1">{{
                            t("save_profile")
                          }}</span>
                        </span>
                      }
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-white dark:bg-base-200">
              <input
                [(ngModel)]="isOrgAddress"
                type="checkbox"
                name="org_address"
              />
              <div
                class="collapse-title font-normal flex items-center text-base"
              >
                <span>{{ t("org_address") }}</span>
              </div>

              <div class="collapse-content bg-white dark:bg-base-200">
                <form #orgAddressForm="ngForm" class="w-full">
                  <div class="flex justify-start items-center my-2 w-full">
                    <button
                      [disabled]="loading()"
                      (click)="toggleEditAddress()"
                      class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
                    >
                      @if (isEditAddress()) {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-circle-xmark"></i>
                          <span class="mt-1" *transloco="let t">{{
                            t("cancel")
                          }}</span>
                        </span>
                      } @else {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-pen-to-square"></i>
                          <span class="mt-1">{{ t("edit_address") }}</span>
                        </span>
                      }
                    </button>
                    <button
                      (click)="updateOrgAddress()"
                      type="button"
                      [disabled]="loading() || !orgAddressForm.valid"
                      *ngIf="isEditAddress()"
                      class="btn sticky top-0 btn-success btn-xs rounded-box ml-auto"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgAddressForm.valid,
                            'text-neutral-600': orgAddressForm.invalid,
                          }"
                        >
                          <i class="fa-light text-sm fa-circle-check"></i>
                          <span class="mt-1">{{ t("save_address") }}</span>
                        </span>
                      }
                    </button>
                  </div>
                  <div class="grid grid-cols-1 gap-2">
                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("country") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <input
                        hidden
                        required
                        type="text"
                        name="country"
                        [(ngModel)]="selectedCountry"
                      />
                      <button
                        type="button"
                        [disabled]="!isEditAddress() || loading()"
                        (click)="openModal('select-country')"
                        class="!bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row font-normal hover:bg-base-300 hover:border-neutral-400 items-center justify-between px-4 py-2 rounded-box text-sm text-base-content w-full"
                      >
                        @if (selectedCountry()) {
                          <div
                            class="flex flex-row gap-2 justify-center items-center"
                          >
                            <div class="rounded-full w-8 h-8">
                              <img
                                src="/assets/icons/flags/{{
                                  selectedCountry()?.code
                                }}.svg"
                                class=""
                                alt=""
                              />
                            </div>
                            <span class="mt-1 !text-base-content">{{
                              selectedCountry()?.name
                            }}</span>
                          </div>
                        } @else {
                          <div
                            class="flex flex-row gap-2 justify-center items-center"
                          >
                            <div
                              class="rounded-full w-8 h-8 bg-neutral-400"
                            ></div>
                            <span class="mt-1">{{ t("select_country") }}</span>
                          </div>
                        }
                        <i class="fa-solid fa-chevron-down text-xl mr-1"></i>
                      </button>
                    </label>

                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("city") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <input
                        hidden
                        required
                        type="text"
                        name="city"
                        [(ngModel)]="selectedCity"
                      />
                      <button
                        type="button"
                        [disabled]="
                          !isEditAddress() || loading() || !citiesLoaded()
                        "
                        (click)="openModal('select-city')"
                        class="!bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row font-normal hover:bg-base-300 hover:border-neutral-400 items-center justify-between px-4 py-2 rounded-box text-sm text-base-content w-full"
                      >
                        @if (selectedCity()) {
                          <div
                            class="flex flex-row gap-2 justify-start items-center"
                          >
                            <span class="mt-1 !text-base-content">{{
                              selectedCity()?.name
                            }}</span>
                          </div>
                        } @else {
                          <div
                            class="flex flex-row gap-2 justify-center items-center"
                          >
                            <span class="mt-1">{{ t("select_city") }}</span>
                          </div>
                        }
                        <i class="fa-solid fa-chevron-down text-xl mr-1"></i>
                      </button>
                    </label>

                    <label
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text">{{ t("description") }} </span>
                      </div>
                      <textarea
                        [disabled]="!isEditAddress() || loading()"
                        class="textarea textarea-bordered h-24 w-full rounded-box dark:!text-neutral-content !text-neutral-800 dark:disabled:!text-neutral-content disabled:!text-neutral-800"
                        placeholder="{{ t('description_placeholder') }}"
                        name="description"
                        [(ngModel)]="description"
                      ></textarea>
                    </label>

                    <button
                      (click)="updateOrgAddress()"
                      type="button"
                      [disabled]="loading() || !orgAddressForm.valid"
                      *ngIf="isEditAddress()"
                      class="btn btn-success btn-md rounded-box w-full"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgAddressForm.valid,
                            'text-neutral-600': orgAddressForm.invalid,
                          }"
                        >
                          <i class="fa-light text-lg fa-circle-check"></i>
                          <span class="text-lg mt-1">{{
                            t("save_address")
                          }}</span>
                        </span>
                      }
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-white dark:bg-base-200">
              <input
                [(ngModel)]="isOrgContact"
                type="checkbox"
                name="org_contact"
              />
              <div
                class="collapse-title font-normal flex items-center text-base"
              >
                <span>{{ t("org_contact") }}</span>
              </div>
              <div class="collapse-content bg-white dark:bg-base-200">
                <form #orgContactForm="ngForm" class="w-full">
                  <div class="flex justify-start items-center my-2 w-full">
                    <button
                      [disabled]="loading()"
                      (click)="toggleEditContact()"
                      class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
                    >
                      @if (isEditContact()) {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-circle-xmark"></i>
                          <span class="mt-1" *transloco="let t">{{
                            t("cancel")
                          }}</span>
                        </span>
                      } @else {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-pen-to-square"></i>
                          <span class="mt-1">{{ t("edit_contact") }}</span>
                        </span>
                      }
                    </button>
                    <button
                      (click)="updateOrgContact()"
                      type="button"
                      [disabled]="loading() || !orgContactForm.valid"
                      *ngIf="isEditContact()"
                      class="btn sticky top-0 btn-success btn-xs rounded-box ml-auto"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgContactForm.valid,
                            'text-neutral-600': orgContactForm.invalid,
                          }"
                        >
                          <i class="fa-light text-sm fa-circle-check"></i>
                          <span class="mt-1">{{ t("save_contact") }}</span>
                        </span>
                      }
                    </button>
                  </div>
                  <div class="grid grid-cols-1 gap-2">
                    <label
                      for="org_phone"
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("org_phone_label") }}
                          </span>
                          <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span>
                        </span>
                      </div>
                      <label
                        for="org_phone"
                        class="flex bg-base-100 font-semibold gap-0 h-full input items-center text-xl text-base-content py-2 rounded-box w-full input-bordered"
                      >
                        <span
                          class="mt-1 text-neutral-600 dark:!text-neutral-400"
                          [ngClass]="{
                            '!text-neutral-400 dark:!text-neutral-500':
                              !isEditContact(),
                          }"
                          >{{ selectedCountry()?.phone_code }}</span
                        >
                        <input
                          type="text"
                          class="mt-1"
                          #orgPhone
                          (paste)="formatPhoneNumberOnPaste($event)"
                          (keyup)="phoneNumberChange($event)"
                          [(ngModel)]="phoneNumber"
                          [placeholder]="t('org_phone_placeholder')"
                          name="org_phone"
                          inputmode="numeric"
                          required
                          type="tel"
                          [disabled]="!isEditContact() || loading()"
                        />
                      </label>
                    </label>
                    <label
                      for="email"
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("org_email") }}
                          </span>
                          <!-- <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span> -->
                        </span>
                      </div>
                      <input
                        #orgEmail="ngModel"
                        [(ngModel)]="email"
                        type="email"
                        name="email"
                        [placeholder]="t('org_email_placeholder')"
                        class="input input-bordered input-md text-lg w-full rounded-box"
                        [ngClass]="
                          orgEmail.invalid && orgEmail.touched
                            ? 'input-error text-error'
                            : ''
                        "
                        [disabled]="!isEditContact() || loading()"
                      />
                    </label>

                    <button
                      (click)="updateOrgContact()"
                      type="button"
                      [disabled]="loading() || !orgContactForm.valid"
                      *ngIf="isEditContact()"
                      class="btn btn-success btn-md rounded-box w-full"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgContactForm.valid,
                            'text-neutral-600': orgContactForm.invalid,
                          }"
                        >
                          <i class="fa-light text-lg fa-circle-check"></i>
                          <span class="text-lg mt-1">{{
                            t("save_contact")
                          }}</span>
                        </span>
                      }
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="collapse collapse-arrow bg-white dark:bg-base-200">
              <input [(ngModel)]="isOrgWifi" type="checkbox" name="org_wifi" />
              <div
                class="collapse-title font-normal flex items-center text-base"
              >
                <span>{{ t("org_wifi") }}</span>
              </div>
              <div class="collapse-content bg-white dark:bg-base-200">
                <form #orgWifiForm="ngForm" class="w-full">
                  <div class="flex justify-start items-center my-2 w-full">
                    <button
                      [disabled]="loading()"
                      (click)="toggleEditWifi()"
                      class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
                    >
                      @if (isEditWifi()) {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-circle-xmark"></i>
                          <span class="mt-1" *transloco="let t">{{
                            t("cancel")
                          }}</span>
                        </span>
                      } @else {
                        <span class="flex items-center gap-1">
                          <i class="fa-light text-sm fa-pen-to-square"></i>
                          <span class="mt-1">{{ t("edit_access") }}</span>
                        </span>
                      }
                    </button>
                    <button
                      (click)="updateOrgWifi()"
                      type="button"
                      [disabled]="loading() || !orgWifiForm.valid"
                      *ngIf="isEditWifi()"
                      class="btn sticky top-0 btn-success btn-xs rounded-box ml-auto"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgWifiForm.valid,
                            'text-neutral-600': orgWifiForm.invalid,
                          }"
                        >
                          <i class="fa-light text-sm fa-circle-check"></i>
                          <span class="mt-1">{{ t("save_access") }}</span>
                        </span>
                      }
                    </button>
                  </div>
                  <div class="grid grid-cols-1 gap-2">
                    <label
                      for="wifi"
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("org_wifi_name") }}
                          </span>
                          <!-- <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span> -->
                        </span>
                      </div>
                      <input
                        #orgWifi="ngModel"
                        [(ngModel)]="wifiName"
                        type="text"
                        name="wifi"
                        [placeholder]="t('wifi_name')"
                        class="input input-bordered input-md text-lg w-full rounded-box"
                        [ngClass]="
                          orgWifi.invalid && orgWifi.touched
                            ? 'input-error text-error'
                            : ''
                        "
                        [disabled]="!isEditWifi() || loading()"
                      />
                    </label>

                    <label
                      for="wifi_password"
                      class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                    >
                      <div class="label">
                        <span class="label-text flex gap-1">
                          <span>
                            {{ t("org_wifi_password") }}
                          </span>
                          <!-- <span
                            class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                          ></span> -->
                        </span>
                      </div>
                      <input
                        #orgWifiPassword="ngModel"
                        [(ngModel)]="wifiPassword"
                        type="text"
                        name="wifiPassword"
                        [placeholder]="t('wifi_password')"
                        class="input input-bordered input-md text-lg w-full rounded-box"
                        [ngClass]="
                          orgWifiPassword.invalid && orgWifiPassword.touched
                            ? 'input-error text-error'
                            : ''
                        "
                        [disabled]="!isEditWifi() || loading()"
                      />
                    </label>

                    <button
                      (click)="updateOrgWifi()"
                      type="button"
                      [disabled]="loading() || !orgWifiForm.valid"
                      *ngIf="isEditWifi()"
                      class="btn btn-success btn-md rounded-box w-full"
                    >
                      @if (loading()) {
                        <span class="loading loading-spinner"></span>
                      } @else {
                        <span
                          class="flex items-center gap-2"
                          [ngClass]="{
                            'text-white': orgWifiForm.valid,
                            'text-neutral-600': orgWifiForm.invalid,
                          }"
                        >
                          <i class="fa-light text-lg fa-circle-check"></i>
                          <span class="text-lg mt-1">{{
                            t("save_access")
                          }}</span>
                        </span>
                      }
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        }

        @if (isPreview()) {
          <div class="mockup-phone">
            <div class="camera"></div>
            <div class="display !px-0">
              <div
                class="artboard phone-1 !flex !flex-col justify-start relative !px-0"
              >
                <div
                  *ngIf="bannerLink()"
                  class="card z-[10] absolute top-0 h-40"
                >
                  <figure class="!rounded-none">
                    <img
                      class="w-full h-full object-cover"
                      [src]="bannerLink()"
                    />
                  </figure>
                </div>
                <div class="flex w-full max-w-md z-[50] h-full overflow-y-auto">
                  <div
                    class="flex flex-col bg-neutral-100 dark:bg-base-300 rounded-t-box w-full h-full px-2 pt-3 pb-10 relative"
                    [ngClass]="{
                      'mt-40': bannerLink(),
                    }"
                  >
                    <section
                      class="relative z-[50] bg-white dark:bg-base-100 py-2 rounded-box shadow-sm"
                    >
                      @if (logo()) {
                        <div
                          class="avatar self-center w-full justify-center bg-transparent"
                          [ngClass]="{
                            ' -mt-16': bannerLink(),
                          }"
                        >
                          <div
                            class="size-20 overflow-hidden relative flex self-center"
                          >
                            <img
                              class="absolute w-full h-full object-cover"
                              [src]="logoLink()"
                            />
                          </div>
                        </div>
                      }
                      <!-- <span class="loading loading-spinner text-4xl"></span> -->
                      <section class="text-center z-[40]">
                        <h1 class="font-semibold">
                          {{ org()?.store_name }}
                        </h1>
                        <p
                          class="text-sm dark:text-neutral-600 text-neutral-400"
                        >
                          {{ selectedCity()?.name }},
                          {{ $any(org()?.country).name }}
                        </p>
                        <section
                          class="flex gap-2 m-auto justify-center items-center rounded-box p-2 w-fit"
                        >
                          <a
                            [href]="callString()"
                            class="btn btn-sm bg-base-300 dark:bg-base-200 hover:md:btn-primary rounded-box px-4 py-0"
                          >
                            <div class="flex items-center gap-1">
                              <i class="fa-solid fa-phone text-sm"></i>
                              <span class="mt-1 text-base">
                                {{ t("call") }}</span
                              >
                            </div>
                          </a>
                        </section>
                      </section>
                    </section>

                    <section class="flex w-full">
                      <div
                        class="collapse collapse-arrow bg-white dark:bg-base-100 rounded-box mt-2 shadow-sm"
                      >
                        <input type="checkbox" name="payment_methods" checked />
                        <div class="collapse-title font-normal">
                          {{ t("payment_methods") }}
                        </div>
                        <div class="collapse-content bg-base-200 px-2">
                          @for (
                            account of orgPaymentAccounts();
                            track $index;
                            let count = $count
                          ) {
                            @if (loading()) {
                              <div
                                class="flex items-center justify-center gap-2 rounded-box px-4 py-2 text-neutral-400 text-center my-2"
                              >
                                <span
                                  class="loading loading-spinner w-9"
                                ></span>
                              </div>
                            } @else {
                              <button
                                type="button"
                                [disabled]="loading()"
                                class="btn flex flex-row justify-between items-center p-2 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-fit hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
                              >
                                <div
                                  class="flex flex-row gap-3 justify-center items-center"
                                >
                                  <div
                                    class="rounded-full size-11 bg-neutral-400"
                                  >
                                    <img
                                      src="/assets/icons/providers/{{
                                        account.payment_provider?.icon
                                      }}"
                                      class=""
                                      alt=""
                                    />
                                  </div>
                                  <div class="flex flex-col items-start">
                                    <span class="text-base">{{
                                      $any($any(account)?.payment_provider)
                                        ?.name
                                    }}</span>
                                    <span
                                      class="text-md text-neutral-500 dark:text-neutral-400"
                                      >{{ account.number_display }}</span
                                    >
                                  </div>
                                </div>
                                <i
                                  class="fa-light fa-chevron-right text-neutral-500 text-xl mr-1"
                                ></i>
                              </button>
                            }
                          } @empty {
                            @if (loading()) {
                              <div
                                class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
                              >
                                <span
                                  class="loading loading-spinner w-9"
                                ></span>
                              </div>
                            } @else {
                              <div
                                class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
                              >
                                <i
                                  class="fa-light fa-xmark-to-slot text-lg"
                                ></i>
                                <p class="text-md mt-1">
                                  {{ t("no_payment_accounts") }}
                                </p>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Org Category list modal -->
  <qwiko-modal
    [id]="'select-category'"
    [isFullScreen]="true"
    [isCentered]="true"
    [enforceHeight]="true"
  >
    <div
      class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
    >
      <div class="flex justify-between items-center mb-2 w-full">
        <span class="size-10"></span>
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="closeModal('select-category')"
        >
          <span class="flex items-center gap-1">
            <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
              t("close")
            }}</span>
            <i class="fa-light text-base fa-xmark"></i>
          </span>
        </button>
      </div>
      <div class="w-full px-4 py-2 mx-auto">
        <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
          {{ t("select_category") }}
        </h2>
        <label
          class="input border border-neutral-400 focus-within:!outline-none flex items-center gap-2 rounded-full w-full md:w-8/12 mx-auto"
        >
          <i class="fa-solid fa-magnifying-glass text-lg text-neutral-400"></i>
          <input
            id="categoryFilter"
            type="text"
            class="grow"
            [(ngModel)]="categoryFilter"
            [placeholder]="t('search')"
            name="categoryFilter"
          />
        </label>
      </div>
    </div>

    <div
      class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6 overflow-y-auto"
      [ngClass]="{ 'md:pb-[11.5rem]': categories().length > 10 }"
    >
      @for (
        category of categories() | textSearch: categoryFilter();
        track $index;
        let count = $count
      ) {
        @if (this.loading()) {
          <div
            class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
          >
            <i class="fa-light fa-earth-africa text-lg"></i>
            <span class="loading text-sm loading-spinner"></span>
          </div>
        } @else {
          <button
            type="button"
            (click)="selectCategory(category)"
            class="btn flex flex-row justify-between items-center py-2 px-3 w-full text-md text-base-content font-normal bg-base-200 h-auto hover:bg-base-100 first:mt-3 last:mb-3 first:rounded-t-xl last:rounded-b-xl only:rounded-xl rounded-none border-[0.7px] border-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
            [ngClass]="
              selectedCategory()?.id == category.id
                ? '!bg-primary hover:!bg-primary !text-white'
                : ''
            "
          >
            <div class="flex flex-row gap-2 justify-start items-center w-full">
              <span class="flex items-center justify-between w-full text-base">
                <span>{{ category.name }}</span>
                <!-- <span class="flex gap-1 items-center text-base">
                    @if (selectedCategory()?.id == category.id) {
                      <i class="fa-solid fa-circle-check text-lg text-primary"></i>
                    }
                  </span> -->
              </span>
            </div>
          </button>
        }
      } @empty {
        @if (this.loading()) {
          <div
            class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
          >
            <i class="fa-light fa-earth-africa text-lg"></i>
            <p class="text-md mt-1">{{ t("loading") }}</p>
          </div>
        } @else {
          <div
            class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
          >
            <i class="fa-light fa-earth-africa text-lg"></i>
            <p class="text-md mt-1">{{ t("no_categories") }}</p>
          </div>
        }
      }
    </div>
  </qwiko-modal>

  <!-- Countries list modal -->
  <qwiko-modal
    [id]="'select-country'"
    [isFullScreen]="true"
    [isCentered]="true"
    [enforceHeight]="true"
  >
    <div
      class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
    >
      <div class="flex justify-between items-center mb-2 w-full">
        <span class="size-10"></span>
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="closeModal('select-country')"
        >
          <span class="flex items-center gap-1">
            <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
              t("close")
            }}</span>
            <i class="fa-light text-base fa-xmark"></i>
          </span>
        </button>
      </div>
      <div class="w-full px-4 py-2 mx-auto">
        <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
          {{ t("select_country") }}
        </h2>
        <label
          class="input border border-neutral-400 focus-within:!outline-none flex items-center gap-2 rounded-full w-full md:w-8/12 mx-auto"
        >
          <i class="fa-solid fa-magnifying-glass text-lg text-neutral-400"></i>
          <input
            id="countryFilter"
            type="text"
            class="grow"
            [(ngModel)]="countryFilter"
            [placeholder]="t('search')"
            name="countryFilter"
          />
        </label>
      </div>
    </div>

    <div
      class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6 overflow-y-auto"
      [ngClass]="{ 'md:pb-[11.5rem]': countries().length > 10 }"
    >
      @for (
        country of countries() | textSearch: countryFilter();
        track $index;
        let count = $count
      ) {
        <button
          type="button"
          (click)="selectCountry(country)"
          class="btn flex flex-row justify-between items-center py-2 px-3 w-full text-md text-base-content font-normal bg-base-200 h-auto hover:bg-base-100 first:mt-3 last:mb-3 first:rounded-t-xl last:rounded-b-xl only:rounded-xl rounded-none border-[0.7px] border-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
          [ngClass]="
            selectedCountry()?.id == country.id
              ? '!bg-primary hover:!bg-primary !text-white'
              : ''
          "
        >
          <div class="flex flex-row gap-2 justify-center items-center w-full">
            <div class="rounded-full w-9 h-9">
              <img
                src="/assets/icons/flags/{{ country.code }}.svg"
                class=""
                alt=""
              />
            </div>
            <!-- <span class="mt-1 text-2xl">{{country.emoji}}</span> -->
            <span class="flex items-center justify-start w-full text-base">
              <span>{{ country.name }}</span>
            </span>
          </div>
        </button>
      } @empty {
        <div
          class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
        >
          <i class="fa-light fa-earth-africa text-lg"></i>
          <p class="text-md mt-1">{{ t("no_countries") }}</p>
        </div>
      }
    </div>
  </qwiko-modal>

  <!-- City list modal -->
  <qwiko-modal
    [id]="'select-city'"
    [isFullScreen]="true"
    [isCentered]="true"
    [enforceHeight]="true"
  >
    <div
      class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
    >
      <div class="flex justify-between items-center mb-2 w-full">
        <span class="size-10"></span>
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="closeModal('select-city')"
        >
          <span class="flex items-center gap-1">
            <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
              t("close")
            }}</span>
            <i class="fa-light text-base fa-xmark"></i>
          </span>
        </button>
      </div>
      <div class="w-full px-4 py-2 mx-auto">
        <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
          {{ t("select_city") }}
        </h2>
        <label
          class="input border border-neutral-400 focus-within:!outline-none flex items-center gap-2 rounded-full w-full md:w-8/12 mx-auto"
        >
          <i class="fa-solid fa-magnifying-glass text-lg text-neutral-400"></i>
          <input
            id="cityFilter"
            type="text"
            class="grow"
            [(ngModel)]="cityFilter"
            [placeholder]="t('search')"
            name="cityFilter"
          />
        </label>
      </div>
    </div>

    <div
      class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6 overflow-y-auto"
      [ngClass]="{ 'md:pb-[11.5rem]': cities().length > 10 }"
    >
      @for (
        city of cities() | textSearch: cityFilter();
        track $index;
        let count = $count
      ) {
        <button
          type="button"
          (click)="selectCity(city)"
          class="btn flex flex-row justify-between items-center py-2 px-3 w-full text-md text-base-content font-normal bg-base-200 h-auto hover:bg-base-100 first:mt-3 last:mb-3 first:rounded-t-xl last:rounded-b-xl only:rounded-xl rounded-none border-[0.7px] border-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
          [ngClass]="
            selectedCity()?.id == city.id
              ? '!bg-primary hover:!bg-primary !text-white'
              : ''
          "
        >
          <div class="flex flex-row gap-2 justify-start items-center w-full">
            <span class="flex items-center justify-between w-full text-base">
              <span>{{ city.name }}</span>
              <span class="flex gap-1 items-center text-base">
                <!-- @if (selectedCity()?.id == city.id) {
                    <i class="fa-solid fa-circle-check text-lg text-primary"></i>
                  } -->
              </span>
            </span>
          </div>
        </button>
      } @empty {
        @if (!loading()) {
          <div
            class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
          >
            <i class="fa-light fa-earth-africa text-lg"></i>
            <p class="text-md mt-1">{{ t("no_cities") }}</p>
          </div>
        } @else {
          <div
            class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
          >
            <span class="loading loading-spinner w-9"></span>
          </div>
        }
      }
    </div>
  </qwiko-modal>
</ng-container>
